export const getTextType = (textType, isFallbackToDictionaryTerm = false) => {
  if (isFallbackToDictionaryTerm) {
    return 'DictionaryTerm';
  } else {
    return textType;
  }
};
